module.exports = __webpack_public_path__ + "static/img/home_icon_discounts_1.7a2cb41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/home_icon_discounts_1.png
// module id = DvCZ
// module chunks = 0